import ApiService from './ApiService';

class UsersService extends ApiService {
    constructor() {
        super();

        this._locale = 'ru';
        this._availableUrl = '/reports/available';
    }

    getAvailable() {
        return this.postResource(this._availableUrl);
    }
}

const service = new UsersService();

export default service;
